import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconNumber7Circle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNumber7Circle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M9.88281 16.25L13.6797 8.82031V8.73828H9.15625V7.79492H14.752V8.77344L10.9902 16.25H9.88281Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber7Circle;
